import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const LandingPage = loadable(() => withDefaultLoaderModifiers(import("./LandingPage")));
